<template>
  <div class="keyBorrow">
    <div class="titDiv">请选择需要领取的钥匙</div>
    <div class="tips">已选择钥匙：{{checkList.length}}（把）</div>
    <div class="cont">
      <el-checkbox-group v-model="checkList" @change="time = 60">
      <swiper :options="swiperOption" ref="mySwiper">
        <!-- slides -->
          <swiper-slide v-for="(item,index) in pageCount" :key="index">
            <div class="list">
                <el-checkbox :label="box.cell_id" :class="{item,'disItem':box.lock_status == 2}" :disabled="box.lock_status == 2" v-for="(box,index2) in boxList[index]" :key="index2">
                  <div class="num">{{box.cell_id}}</div>
                  <div class="img"><img src="../../../../static/images/key.png" alt="" v-if="box.lock_status != 2"></div>
                  <div class="name" :ref="'name2'+index+''+index2">
                    <div v-if="box.isScrll == false" :ref="'name1'+index+''+index2" class="name1">{{box.name}}</div>
                    <marquee behavior="scroll" v-else>{{box.name}}</marquee>
                  </div>
                  <!-- <div class="name">{{box.category}}</div> -->
                </el-checkbox>
                <!-- <el-checkbox label="2" class="item disItem">
                  <div class="num">02</div>
                  <div class="img"></div>
                  <div class="name">工具柜钥匙</div>
                </el-checkbox>
                <el-checkbox label="3" class="item">
                  <div class="num">03</div>
                  <div class="img"><img src="../../../../static/images/key.png" alt=""></div>
                  <div class="name">工具柜钥匙</div>
                </el-checkbox> -->
              
            </div>
          </swiper-slide>
        
        <!-- Optional controls -->
        <div class="swiper-pagination"  slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
      </el-checkbox-group>
    </div>
    <div class="backUp">
      <el-button @click="toBorrow">确认借用</el-button>
      <el-button @click="loginOut">退出登录</el-button>
    </div>
    <div class="adminBtn">
      <el-button type="info" @click="toBiosign">员工生物特征录入</el-button>
    </div>
    <currtime :isShowInfo="false"></currtime>
  </div>
</template>

<script>
import currtime from '../../../assets/currTime'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { checkData,strToHexCharCode } from '../../../../static/js/utils/util.js'
import { showLoading,hideLoading,localUserInfo,storage } from '../../../../static/js/utils/utility.js'
import { borrowApi,keyCabinetApi } from "../../../../static/js/api.js"
import * as config from '../../../../static/js/config.js';
import qs from 'qs'
var vm
export default {
  name: 'keyBorrow',
  data () {
    
    return {

      topic:'/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol/response',
      msg:'',
      isConnect:true,//是否默认订阅

      activeIndex: 0,
      isAdmin:'',//是否是管理员
      user_id:'',//用户id
      keyword:'',//搜索关键词
      boxList:[],//箱格列表
      allList:[],//所有列表

      pageCount:0,//总页数
      limits:18,//每页显示数

      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets:true,
        },
        on: {
          slideChangeTransitionStart(){
            vm.activeIndex = vm.$refs.mySwiper.swiper.activeIndex
            var index = vm.$refs.mySwiper.swiper.activeIndex
            
            for(var ii in vm.boxList[index]){
              var ref1 = 'name1'+index+ii
              var ref2 = 'name2'+index+ii
              if(vm.$refs[ref1].length!=0){
                if(vm.$refs[ref1][0].offsetWidth > vm.$refs[ref2][0].offsetWidth){
                  vm.boxList[index][ii].isScrll = true
                }
              }
            }
            
          },
        },
        observer:true, 
        observeParents:true
      },

      time:30,
      timeStatus:'',

      checkList:[],
    }
  },
  //定义这个sweiper对象  
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;  
    }  
  },
  mounted(){
    
  },
  created() {
    vm = this
    // this.isAdmin = localUserInfo.getItem().is_admin
    // this.user_id = localUserInfo.getItem().user_id
    this.getBoxList()
    this.getSecond(this.time)
  },
  components:{
    currtime,
    swiper,
    swiperSlide,
  },
  methods:{
    
    //倒计时
    getSecond(wait){
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        // clearTimeout(that.timeStatus)
        that.loginOut()
      } else {
        that.time=wait
        that.time--;
        that.timeStatus = setTimeout(function() {
          that.getSecond(that.time);
        },1000);
      }
    },
    
    //获取箱格列表
    async getBoxList(){
      var that = this
      showLoading();
      var dataObj = {
        'status': 'all',
      }
      var res = await keyCabinetApi.openKey(qs.stringify(dataObj))
      if(res.error == 0 ){
        if(res.cells!=''){
          for(var i in res.cells){
            res.cells[i].isScrll = false
            if(!res.cells[i].name){
              res.cells[i].name = '未命名'
            }
          }
        }
        that.allList = res.cells
        that.screenList()
        hideLoading();
      }else{
        hideLoading();
        that.$message.error('获取异常！')
      }

      // var data = {
      //   'cabinet_id': config.deviceId,
      //   'status': 'all'
      //   // 'user_id':'',//用户id
      // }
      // var res = await keyCabinetApi.getList(data)
      // if (res.meta.code == 200) {
      //   if(res.body!=''){
      //     for(var i in res.body.list){
      //       res.body.list[i].isScrll = false
      //       if(!res.body.list[i].name){
      //         res.body.list[i].name = '未命名'
      //       }
      //     }
      //   }
      //   that.allList = res.body.list
      //   that.screenList()
      //   hideLoading();
      // } else {
      //   hideLoading();
      //   that.$message.error(res.meta.message)
      //   // showToast(res.meta.message)
      // }
    },
    //列表筛选
    screenList(){
      var that = this;
      var allList = that.allList
      var limits = that.limits;//每页显示条数
      var searchList = []
      this.overtime = 60
      
      for(var i in allList){
        if(that.keyword!=''){
          if(allList[i].name.indexOf(that.keyword) != -1){
            searchList.push(allList[i])
          }
        }else{
          searchList = allList
        }
      }
      
      that.pageCount = Math.ceil(searchList.length/limits);
      var arr = []
      for(var i = 0, j = searchList.length; i < j; i += limits){
        arr.push(searchList.slice(i,i+limits))
      }
      that.boxList =arr

      that.$nextTick(function(){
        for(var ii in arr[0]){
          var ref1 = 'name1'+'0'+ii
          var ref2 = 'name2'+'0'+ii
          if(vm.$refs[ref1].length!=0){
            if(that.$refs[ref1][0].offsetWidth > that.$refs[ref2][0].offsetWidth){
              arr[0][ii].isScrll = true
            }
          }
        }
        that.boxList = arr
      })
    },
    
    //退出登录
    loginOut(){
      var that=this
      localUserInfo.removeItem()
      that.$router.push({
        path:'/keyCabinet'
      })
    },
    //借用
    toBorrow(){
      var that = this
      var id = this.checkList
      if(id == ''){
        that.$message('请先选择需要借用的钥匙')
        return
      }
      storage.sessionSetItem('keyCheck',id)
      that.$router.push({
        path:'/keyCabinet/keyOpenDoor',
      })
    },
    //员工生物特征录入
    toBiosign(){
      this.$router.push({
        path:'/toolCabinet/CAdmin/CABiosignAture',
        query:{
          'isType':'key'
        }
      })
    }
  },
  watch :{

  },
  destroyed(){
    clearTimeout(this.timeStatus)
  }
}
</script>

<style lang="less">
.keyBorrow{
  padding: 0.6rem 0 0;
  touch-action: none;
  height: 100vh;
  box-sizing: border-box;
  .titDiv{
    text-align: center;
    font-size: 0.48rem;
    color: #fff;
    font-weight: bold;
  }
  .tips{
    margin:0.3rem 2.28rem 0.1rem;
    font-size: 0.3rem;
    color: #e6e4e4;
  }
  .mt100{
    margin-top: 1rem;
  }
  // .swiper-container-horizontal > .swiper-pagination-bullets{
  //   bottom: 0.15rem;
  // }
  .el-checkbox__label{
    display: block;
    padding: 0 0.1rem !important;
  }
  .swiper-container {
    height: 7.08rem;
    .el-checkbox-group{
      width: 100%;
    }
    .list{
      height: 7.08rem;
      background-color: rgba(255, 255, 255, .1);
      border-radius: 0.1rem;
      margin: 0 2.28rem;
      padding: 0.35rem 0.465rem 0;
      box-sizing: border-box;
      .item{
        background: #fff;
        border-radius: 0.08rem;
        position: relative;
        width: 1.91rem;
        height: 1.74rem;
        font-size: 0.26rem;
        text-align: center;
        overflow: hidden;
        margin: 0 0.185rem 0.31rem;
        &.disItem{
          .img{
            background: #c4c5c6;
          }
          .name{
            color: #999;
            line-height: 1;
            // width: 1.71rem;
            .name1{
              white-space: nowrap;
              display: inline;
            }
          }
        }
        .img{
          width: 0.65rem;
          height: 0.65rem;
          border-radius: 50%;
          background: #2d83f4;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0.22rem auto 0.35rem;
          img{
            width: 0.21rem;
            height: 0.4rem;
          }
        }
        .name{
          font-size: 0.26rem;
          color: #333;
          line-height: 1;
          // width: 1.71rem;
          .name1{
            white-space: nowrap;
            display: inline;
          }
        }
        .el-checkbox__input{
          position: absolute;
          right: 0;
          top: 0;
          .el-checkbox__inner{
            width: 0.55rem;
            height: 0.54rem;
            border: none;
            display: block;
            border-radius: 0;
            background: none;
          }
        }
        .el-checkbox__input.is-checked .el-checkbox__inner::after{
          content: "";
          background: url('../../../../static/images/check.png') no-repeat;
          background-size: cover;
          width: 0.55rem;
          height: 0.54rem;
          left: 0;
          top: 0;
          border:none;
          transform: none;
        }
        .num{
          position: absolute;
          left: 0;
          top: 0.11rem;
          font-size: 0.24rem;
          color: #333;
          background: #c9dffc;
          border-top-right-radius: 0.08rem;
          border-bottom-right-radius: 0.08rem;
          padding: 0.03rem 0.05rem;
        }
      }
    }
  }
  .backUp{
    position: absolute;
    right: 0.94rem;
    bottom: 0.43rem;
    z-index: 2000;
    .el-button{
      height: 0.94rem;
      width: 2.54rem;
      padding: 0;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
      margin-left: 0.2rem;
    }
  }
  .adminBtn{
    position: absolute;
    left: 0.94rem;
    bottom: 0.47rem;
    z-index: 99;
    .el-button{
      height: 0.94rem;
      // width: 2.54rem;
      padding: 0 0.6rem;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
  }
  
  .currTime{
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/keyCabinet/keyBorrow/keyBorrow.vue